import React, { useMemo, memo } from 'react';
import './StreamEmbed.css';

function StreamEmbed({ channel = 'jizonn' }) {
  const src = useMemo(() => {
    const parent = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
    return `https://player.twitch.tv/?channel=${encodeURIComponent(channel)}&parent=${encodeURIComponent(parent)}`;
  }, [channel]);

  return (
    <div className="embed-responsive">
      <iframe
        src={src}
        title={`Twitch - ${channel}`}
        frameBorder="0"
        scrolling="no"
        allowFullScreen={true}
        loading="lazy"
      />
    </div>
  );
}

export default memo(StreamEmbed);
